var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Rating } from '@mui/material';
import { getFeedbackRatingColor } from '../../../helpers';
import { UnFilledStar } from '../icons';
var FeedbackRating = function (props) {
    var _a = __read(useState(-1), 2), hover = _a[0], setHover = _a[1];
    return (React.createElement(Rating, __assign({ size: "large", icon: React.createElement(UnFilledStar, { className: 'lfc-mr-2', fill: getFeedbackRatingColor(hover === -1 ? props.value : hover).fill, stroke: getFeedbackRatingColor(hover === -1 ? props.value : hover).stroke }), emptyIcon: React.createElement(UnFilledStar, { className: 'lfc-mr-2' }), onChangeActive: function (event, value) {
            setHover(value);
        } }, props)));
};
export default FeedbackRating;
//# sourceMappingURL=FeedbackRating.js.map